import { feedbackConstants } from 'Constants/feedback.constants';
import Request from 'Services/request';
import { alterQueryRequest, findCurrentPageRequest, queryParser } from 'Helpers/urlform'
import { toast as toastr } from 'react-toastify';
import { handleApiError } from 'Helpers/index';

const requestFeedback = feedback => ({
    type:  feedbackConstants.FEEDBACK_REQUEST,
    feedback
})

const successFeedback = feedbackObj => ({
    type:  feedbackConstants.FEEDBACK_GET_SUCCESS,
    feedback: feedbackObj.data,
    totalRecords: feedbackObj.count,
    currentPage: feedbackObj.currentPage
})

const failureFeedback = error => ({
    type:  feedbackConstants.FEEDBACK_FAILURE,
    error
})

const requesUpdatetFeedback = feedback => ({
    type:  feedbackConstants.FEEDBACK_FORM_REQUEST,
    feedback
})

const successUpdateFeedback = feedbackObj => ({
    type: feedbackConstants.UPDATE_FEEDBACK_SUCCESS,
    feedback: feedbackObj
})

const failureSaveFeedback = error => ({
    type: feedbackConstants.FEEDBACK_SAVE_FORM_FAILURE,
    error
})

function fetchFeedback(SearchArray) {
    let url = '/reports';
    if (SearchArray && SearchArray.length > 0) {
        url = queryParser(url, SearchArray);
    }
    const currentPage = findCurrentPageRequest(SearchArray);
    return async (dispatch) => {
        dispatch(requestFeedback({}));
        await Request.get(url, {})
            .then((response) => {
                const { data, count } = response;
                dispatch(successFeedback({ data, count, currentPage }));
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureFeedback(error.toString()));
                }
            });
    };
}

function updateFeedback(feedbackObj, SearchArray) {
    const { id, description, ...rest } = feedbackObj
    return (dispatch) => {
        dispatch(requesUpdatetFeedback({}));
        Request.update(`/reports/${ id }`,
            { description })
            .then((response) => {
                const { message } = response;
                dispatch(successUpdateFeedback(feedbackObj));
                dispatch(fetchFeedback(SearchArray))
                toastr.dismiss();
                toastr.success(message);
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureSaveFeedback(error.toString()));
                }
            });
    };
}

function deleteFeedback(id, SearchArray, remainningRecords, currentPage) {
    const updateSearchArray = alterQueryRequest(SearchArray, remainningRecords, currentPage);
    return (dispatch) => {
        dispatch(requestFeedback({}));
        Request.remove(`/feedback?id=${ id }`, {})
            .then((response) => {
                const { message } = response;
                dispatch(fetchFeedback(updateSearchArray));
                toastr.dismiss();
                toastr.success(message);
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureFeedback(error.toString()));
                }
            });
    }
}

const requestFeedbackExportData = exportData => ({
    type: feedbackConstants.EXPORT_FEEDBACK_REQUEST,
    exportData
})

const successFeedbackExportData = exportDataObj => ({
    type: feedbackConstants.EXPORT_FEEDBACK_SUCCESS,
    exportData: exportDataObj.data,
    totalRecords: exportDataObj.count
})

const failureFeedbackExportData = error => ({
    type: feedbackConstants.EXPORT_FEEDBACK_FAILURE,
    error
})

function exportFeedback(SearchArray) {
    let url = '/feedback';
    if (SearchArray && SearchArray.length > 0) {
        url = queryParser(url, SearchArray);
    }
    const exportUrl = SearchArray && SearchArray.length > 0 ? `&exportType=true` : `?exportType=true`;
    
    url = `${ url }${ exportUrl }`;
    return async (dispatch) => {
        dispatch(requestFeedbackExportData({}));
        await Request.get(url, {})
            .then(response => {
                const { data = [], count = 10 } = response;
                data.forEach(function(res){ 
                    res[ 'First Name' ] = res.firstName; 
                    res[ 'Last Name' ] = res.lastName; 
                    res[ 'Email' ] = res.email; 
                    res[ 'Device Platform' ] = res.devicePlatform; 
                    res[ 'Device Model' ] = res.deviceModel; 
                    res[ 'App Version' ] = res.appVersion; 
                    res[ 'Description' ] = res.description; 
                    res[ 'Status' ] = res.status === 1 ? 'Enable' : 'Disable'; 
                    delete res.id; delete res.firstName; delete res.lastName;
                    delete res.email; delete res.devicePlatform; delete res.deviceModel;
                    delete res.appVersion; delete res.description; delete res.status; delete res.image;
                });
                dispatch(successFeedbackExportData({ data, count }));
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureFeedbackExportData(error.toString()));
                }
            });
    };
}

function FeedbackDetails(id) {
    // const { id, description, ...rest } = feedbackObj
    return (dispatch) => {
        dispatch(requesUpdatetFeedback({}));
        Request.get(`/reports/${ id }`)
            .then((response) => {
                const { message, data } = response;
                dispatch(successUpdateFeedback(data));
                // dispatch(fetchFeedback(SearchArray))
                toastr.dismiss();
                toastr.success(message);
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureSaveFeedback(error.toString()));
                }
            });
    };
}

export const FeedbackAction = {
    fetchFeedback,
    updateFeedback,
    deleteFeedback,
    exportFeedback,
    FeedbackDetails
}